import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { FeatureTaxVatDetailsComponent } from './vat-details/feature-tax-vat-details.component';
import { VatComponent } from './vat/vat.component';
import { AlgemeenComponent } from './vat/algemeen/algemeen.component';
import { SuppletiesComponent } from './vat/suppleties/suppleties.component';
import { OverzichtComponent } from './vat/overzicht/overzicht.component';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { AdministratieKoppelenComponent } from './vat/administratie-koppelen/administratie-koppelen.component';
import { FiscaleEenheidVatComponent } from './vat/fiscale-eenheid-vat/fiscale-eenheid-vat.component';
import {AangifteVatComponent} from "./vat/aangifte-vat/aangifte-vat.component";
import {AangifteIcpComponent} from "./vat/aangifte-icp/aangifte-icp.component";
import {SharedUiAlertModule} from "@snelstart/ui-alert";


@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiAlertModule,
    FeatureTaxVatDetailsComponent,
    VatComponent,
    AlgemeenComponent,
    SuppletiesComponent,
    OverzichtComponent,
    AdministratieKoppelenComponent,
    FiscaleEenheidVatComponent,
    AangifteVatComponent,
    AangifteIcpComponent,
    SuppletiesComponent
  ],
  declarations: [

  ],
    exports: [FeatureTaxVatDetailsComponent, AlgemeenComponent],
})
export class FeatureTaxVatDetailsModule {}
